import actionTypes from '../constants/action-types';

const blockVariationHTML = (state = {}, action) => {
  if (action.type !== actionTypes.SET_BLOCK_VARIATION_HTML) return state;
  if (state.id !== action.payload.blockId) return state;

  const variations = state.variations.map((variation) => {
    if (variation.id !== action.payload.variationId) return variation;

    return {
      ...variation,
      html: action.payload.html,
    };
  });

  return {
    ...state,
    variations,
  };
};

export default blockVariationHTML;
